import { createContext, useContext } from 'react'
import type { AiAgentContextValue } from './utils/types'

export const AiAgentContext = createContext<AiAgentContextValue | undefined>(undefined)

export const useAiAgent = (): AiAgentContextValue => {
  const context = useContext(AiAgentContext)
  if (!context) {
    throw new Error('useAiAgent must be used within an AiAgentProvider')
  }
  return context
}
